export const DESKTOP_GRID_LARGE_SCREEN_CELL = 43
export const DESKTOP_GRID_MIN_CELL = 28
export const DESKTOP_GRID_MIN_GAP = 8

// limit how far we search for a free spot when a drop would collide
export const MAX_NEAREST_FREE_SEARCH_RADIUS = 2 // grid-cell Manhattan distance
